import {
  DateAdapter,
  MAT_DATE_FORMATS,
  MAT_DATE_LOCALE,
  MatDateFormats,
} from '@angular/material/core';
import {
  LuxonDateAdapter,
  MAT_LUXON_DATE_ADAPTER_OPTIONS,
  MAT_LUXON_DATE_FORMATS,
} from '@angular/material-luxon-adapter';
import { Provider } from '@angular/core';
import { DateTime } from 'luxon';
import { isString } from 'lodash';

export class DayLuxonDateAdapter extends LuxonDateAdapter {
  public override parse(
    value: any,
    parseFormat: string | string[]
  ): DateTime | null {
    if (isString(value)) {
      return DateTime.fromFormat(value, 'yyyy-MM-dd');
    }

    return super.parse(value, parseFormat);
  }

  public override format(date: DateTime, displayFormat: string): string {
    return date.toFormat(displayFormat);
  }
}

export function provideDayLuxonDateProvider(
  formats: MatDateFormats = MAT_LUXON_DATE_FORMATS
): Provider[] {
  return [
    {
      provide: MAT_DATE_FORMATS,
      useValue: formats,
    },
    {
      provide: DateAdapter,
      useClass: DayLuxonDateAdapter,
      deps: [MAT_DATE_LOCALE, MAT_LUXON_DATE_ADAPTER_OPTIONS],
    },
  ];
}
